
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5513|9982)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
